import { Phone, Calculator, ArrowRight, Star } from 'lucide-react';
import { COMPANY_INFO, AI_SATEI_URL, AT_HOME_URL } from '@/constants/company';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const testimonialsJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/testimonials#webpage`,
      url: `${siteUrl}/testimonials`,
      name: 'お客様の声・実績｜名古屋不動産売却 株式会社クリアコーポレーション',
      description: '名古屋の不動産売却・買取をご利用いただいたお客様の声をご紹介。相続・空き家・住み替え・共有持分など様々なケースに対応。満足度98%・累計成約1,200件以上。株式会社クリアコーポレーション。',
      inLanguage: 'ja',
    },
    {
      '@type': 'RealEstateAgent',
      '@id': `${siteUrl}/#organization`,
      name: '株式会社クリアコーポレーション',
      url: siteUrl,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        bestRating: '5',
        worstRating: '1',
        ratingCount: '1200',
        reviewCount: '1200',
      },
    },
  ],
};

const testimonials = [
  {
    id: 1,
    name: '名古屋市北区・K様',
    age: '60代',
    situation: '相続した実家の売却',
    rating: 5,
    title: '近所に知られずに売却できました',
    content: '親が亡くなり、相続した実家の処分に悩んでいました。近所の目が気になって、なかなか動けずにいましたが、クリアコーポレーションさんは秘密厳守で対応してくださり、安心してお願いできました。査定も迅速で、想像以上の価格で買い取っていただき感謝しています。',
    result: '希望価格より15%高値で売却',
    days: '査定後14日で現金化',
  },
  {
    id: 2,
    name: '名古屋市中区・S様',
    age: '40代',
    situation: '住み替えのための売却',
    rating: 5,
    title: 'スピーディーな対応に驚きました',
    content: '新築に住み替えるため、現在のマンションを売却したいと思っていました。他社では何度も営業電話がかかってきて困っていましたが、こちらは一度の相談でスムーズに進み、無駄なストレスがありませんでした。名古屋の市場に詳しいからこその適正価格だったと思います。',
    result: '希望通りの価格で売却完了',
    days: '査定後21日で決済',
  },
  {
    id: 3,
    name: '名古屋市港区・T様',
    age: '70代',
    situation: '空き家の管理が大変で',
    rating: 5,
    title: '遠方からでも安心して任せられました',
    content: '実家が名古屋にあり、私は東京に住んでいるため管理が大変でした。何度も現地に通う必要がなく、書類のやり取りも郵送で完結したのが助かりました。担当者の方が丁寧に説明してくださり、高齢の私にもわかりやすくご説明いただきました。',
    result: '思ったより高値で売却',
    days: '遠方でもスムーズに対応',
  },
  {
    id: 4,
    name: '名古屋市昭和区・M様',
    age: '50代',
    situation: '共有持分の整理',
    rating: 5,
    title: '複雑な持分問題も解決してくれました',
    content: '兄弟で相続した不動産の持分整理で悩んでいました。他の相続人とも円満に話を進めたく、専門的な知識が必要でした。宅建士の資格を持つ担当者が、法的な手続きも含めて丁寧にサポートしてくださり、無事に解決できました。',
    result: '持分整理と売却を同時解決',
    days: '法的手続きも含め2ヶ月で完了',
  },
  {
    id: 5,
    name: '名古屋市天白区・Y様',
    age: '30代',
    situation: '急な資金が必要に',
    rating: 5,
    title: '急ぎの状況でも柔軟に対応',
    content: '事業資金が急に必要になり、自宅を売却することにしました。他社では「もう少し時間がかかります」と言われましたが、クリアコーポレーションさんは私の状況を理解してくださり、スピード買取で対応してくださいました。本当に救われました。',
    result: '急な資金ニーズに対応',
    days: '査定後7日で現金化',
  },
  {
    id: 6,
    name: '名古屋市緑区・H様',
    age: '40代',
    situation: 'ローン返済のため',
    rating: 5,
    title: '正直なアドバイスが心に響きました',
    content: '住宅ローンの返済が厳しくなり、相談させていただきました。売却だけでなく、ローンの状況に応じた様々な選択肢を提示してくださり、最適な解決策を一緒に考えてくださいました。押し売りがまったくなく、本当に私のことを考えてくださっていると感じました。',
    result: '最適な解決策を提案',
    days: '相談から3週間で解決',
  },
];

export default function TestimonialsPage() {
  return (
    <>
      <title>お客様の声・実績｜名古屋不動産売却 株式会社クリアコーポレーション</title>
      <meta name="description" content="名古屋の不動産売却・買取をご利用いただいたお客様の声をご紹介。相続・空き家・住み替え・共有持分など様々なケースに対応。満足度98%・累計成約1,200件以上。株式会社クリアコーポレーション。" />
      <meta name="keywords" content="名古屋 不動産売却 口コミ, 名古屋 不動産買取 評判, クリアコーポレーション 口コミ, 名古屋 不動産 お客様の声" />
      <meta property="og:title" content="お客様の声・実績｜名古屋不動産売却 株式会社クリアコーポレーション" />
      <meta property="og:description" content="名古屋の不動産売却・買取をご利用いただいたお客様の声をご紹介。満足度98%・累計成約1,200件以上。" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://clearcorp.info/testimonials" />
      <script type="application/ld+json">{JSON.stringify(testimonialsJsonLd)}</script>
      <Header />
      <main className="min-h-screen bg-slate-50">
        {/* Hero Section */}
        <section className="bg-slate-900 py-16 md:py-24">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                お客様の声
              </h1>
              <p className="text-slate-300 text-lg max-w-2xl mx-auto">
                実際にご利用いただいたお客様からの声をご紹介します。
                <br />
                様々な状況で、私たちがお手伝いさせていただきました。
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials Grid */}
        <section className="py-16 md:py-24">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {testimonials.map((testimonial) => (
                <article
                  key={testimonial.id}
                  className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-slate-100 flex flex-col"
                >
                  {/* Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-5 h-5 fill-amber-400 text-amber-400"
                      />
                    ))}
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-bold text-slate-900 mb-3">
                    {testimonial.title}
                  </h3>

                  {/* Content */}
                  <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow">
                    {testimonial.content}
                  </p>

                  {/* Result Box */}
                  <div className="bg-slate-50 rounded-lg p-4 mb-4">
                    <div className="flex items-center gap-2 text-emerald-700 font-semibold text-sm mb-1">
                      <i className="ri-checkbox-circle-line"></i>
                      {testimonial.result}
                    </div>
                    <div className="text-slate-500 text-xs">
                      {testimonial.days}
                    </div>
                  </div>

                  {/* Customer Info */}
                  <div className="pt-4 border-t border-slate-100">
                    <div className="text-slate-900 font-semibold">
                      {testimonial.name}
                    </div>
                    <div className="text-slate-500 text-sm">
                      {testimonial.age} / {testimonial.situation}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-white">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                  98%
                </div>
                <div className="text-slate-600 text-sm">お客様満足度</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                  1,200+
                </div>
                <div className="text-slate-600 text-sm">累計成約件数</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                  4.9
                </div>
                <div className="text-slate-600 text-sm">平均評価（5点満点）</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
                  16区
                </div>
                <div className="text-slate-600 text-sm">名古屋全域カバー</div>
              </div>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </>
  );
}
